import en from './locales/en.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import sw from './locales/sw.json';

const resources = {
  en: {
    translation: en,
  },
  sw: {
    translation: sw,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en', // load from localStorage or default to 'en'
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Save language preference to localStorage when language changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
